import React, { useContext } from "react";
import { LocationContext } from "../../contexts";
//import beginTest from "../../assets/img/begin-test.png";
import asVideo from "../../assets/video/as.mp4";
import afVideo from "../../assets/video/af.mp4";
import euVideo from "../../assets/video/eu.mp4";
import naVideo from "../../assets/video/na.mp4";
import saVideo from "../../assets/video/sa.mp4";
import anVideo from "../../assets/video/an.mp4";
import ocVideo from "../../assets/video/oc.mp4";

export const Video = (props) => {
  const location = useContext(LocationContext);

  const video = () => {
    switch (location.continent.toUpperCase()) {
      case "AF":
        return afVideo;
      case "AS":
        return asVideo;
      case "EU":
        return euVideo;
      case "NA":
        return naVideo;
      case "SA":
        return saVideo;
      case "OC":
        return ocVideo;
      case "AN":
        return anVideo;
      default:
        return naVideo;
    }
  };

  /** Render.
   *
   */
  return (
    <>
      <div className='border rounded-3 p-2 mb-3'>
        {location?.continent && (
          <video id='worldVideo' width='100%' autoPlay={true}>
            <source src={video()} />
            Sorry, your browser doesn't support embedded videos.
          </video>
        )}
      </div>
    </>
  );
};
